let lang = process.env.VUE_APP_LANG

if (!lang)
    lang = 'tw'

let langPack = require('./' + lang);

export default langPack.default